export default __webpack_public_path__ + "static/media/move.046bd221.mp3";